import GalleryData from '../data/gallery.json';

export const galleryReducer = () => {
    return GalleryData;
}